/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_trunc.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Rounds down a date to the closest interval since epoch, which starts at `0001-01-01T00:00:00Z`.
 *
 * @example
 * FROM employees
 * | KEEP first_name, last_name, hire_date
 * | EVAL year_hired = DATE_TRUNC(1 year, hire_date)
 *
 * @example
 * FROM employees
 * | EVAL year = DATE_TRUNC(1 year, hire_date)
 * | STATS hires = COUNT(emp_no) BY year
 * | SORT year
 *
 * @example
 * FROM sample_data
 * | EVAL error = CASE(message LIKE "*error*", 1, 0)
 * | EVAL hour = DATE_TRUNC(1 hour, @timestamp)
 * | STATS error_rate = AVG(error) by hour
 * | SORT hour
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'date_trunc',
  signatures: [
    {
      params: [
        {
          name: 'interval',
          type: 'date_period',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'interval',
          type: 'date_period',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'interval',
          type: 'time_duration',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'interval',
          type: 'time_duration',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_nanos',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
